export const isFacebookApp = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1 || ua.indexOf('Instagram') > -1;
};
